import lodash from 'lodash';
import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { WalletAccount } from '@exodus/models';
const { isEqual, isMatch, memoize } = lodash;
const createDeepEqualSelector = createSelectorCreator(defaultMemoize, (a, b) => {
    if (a === b)
        return true;
    return isEqual(a, b);
});
const createDeepEqualOutputSelector = (selectorA, selectorB, combiner) => {
    const inner = createSelector(selectorA, selectorB, combiner);
    return createDeepEqualSelector(inner, (result) => result);
};
const selectorFactory = (allWalletAccountInstancesSelector, activeWalletAccountSelector) => memoize((condition = {}) => createDeepEqualOutputSelector(allWalletAccountInstancesSelector, activeWalletAccountSelector, (walletAccounts, activeWalletAccountName) => {
    return walletAccounts.filter((walletAccount) => {
        const status = {
            enabled: !!walletAccount.enabled,
            custodial: !!walletAccount.isCustodial,
            readOnly: !!(walletAccount.isHardware || walletAccount.is2FA),
            hardware: !!walletAccount.isHardware,
            ledger: walletAccount.source === WalletAccount.LEDGER_SRC,
            trezor: walletAccount.source === WalletAccount.TREZOR_SRC,
            '2FA': !!walletAccount.is2FA,
            active: walletAccount.toString() === activeWalletAccountName,
        };
        return isMatch(status, condition);
    });
}), (options) => JSON.stringify(options));
export default defineSelectorFactory({
    id: 'filter',
    selectorFactory,
    dependencies: [
        { selector: 'all' },
        { selector: 'active' },
    ],
});
